export const state = () => ({
  examDistribute: '',
  examDistributeModal: false,
  examDistributeIds: [],
  examSumary: [],
  examProfessors: [],
  examReload: false,
})

export const mutations = {
  setExamDistribute(state, exam) {
    state.examDistribute = exam
  },
  toggleExamDistributeModal(state) {
    state.examDistributeModal = !state.examDistributeModal
  },
  toggleExamReload(state) {
    state.examReload = !state.examReload
  },
  setExamDistributeIds(state, ids) {
    state.examDistributeIds = ids
  },
  setExamSumary(state, exam) {
    const states = [
      { name: 'Distribuído' },
      { name: 'Distribuir' },
      { name: 'Não enviado' },
    ]
    const countMap = {}
    Object.keys(exam).forEach((key) => {
      countMap[key] = exam[key]
    })
    const newExamSumary = states.map((item) => ({
      name: item.name,
      count: countMap[item.name] || 0,
    }))
    state.examSumary = newExamSumary
  },

  setExamProfessors(state, exam) {
    const keys = Object.keys(exam)
    const professors = []
    keys.forEach((professorName) => {
      if (professorName) {
        professors.push({
          name: professorName,
          exam_count: exam[professorName],
        })
      }
    })
    state.examProfessors = professors
  },
}
